import mary from "Images/profile/rd/rd_mary.jpg";
import matt from "Images/profile/rd/rd_matt.jpg";
import edwin from "Images/profile/rd/rd_edwin.jpg";
import tiffany from "Images/profile/rd/rd_tiffany.jpg";
import laine from "Images/profile/rd/rd_laine.jpg";
import monica from "Images/profile/rd/rd_monica.jpg";
import shana from "Images/profile/rd/rd_shana.jpg";
const getGoalFaq = (goal) => {
    switch (goal) {
        case "Build Muscle":
            return "Your RD can help you with your goal of building muscle by reviewing your current eating habits and providing feedback for improvement, calculating your calorie and macronutrient needs, giving you tips for getting in enough protein throughout the day, helping you to optimize post-workout recovery, reviewing best measurements of progress and setting realistic expectations, and reviewing your fitness routine to ensure it adequately stimulates your muscles for growth.";
        case "Gain Weight":
            return "Your RD can help with your goal of gaining weight by suggesting changes to your current eating habits,  providing  high calorie food and meal suggestions, calculating an appropriate calorie surplus for healthy weight gain, and giving tips on how to combat feeling overly full or bloated while trying to increase your food intake.";
        case "Lose Weight":
            return "Your RD can help you with your weight loss goal by reviewing your current eating habits and providing feedback for improvement, calculating your calorie deficit and macronutrient targets for weight loss, giving you meal and snack ideas that are nutrient dense and calorie controlled, ensuring your goals are realistic and achievable, and helping you to overcome barriers that are in the way of creating and sustaining healthy habits.";
        default:
            return "";
    }
};
const getGoalFaqTitle = (goal) => `How can my Registered Dietitian help me reach my goal of ${goal}`;
export const rdFaqs = [
    {
        title: () => "What can I expect from my Registered Dietitian (RD)?",
        text: () => 'As your personal dietitian, I am here to provide support and answer any questions that come up along the way to reaching your goals. The majority of the RD experience is driven by you and your needs. I can start by addressing any initial questions that you have, or you can take the <a style="text-decoration: underline;" href="/quiz-new/quiz_rd/">RD Check-in Survey</a> to get the conversation started, and I will follow up within 1 business day.',
    },
    {
        title: (goal) => getGoalFaqTitle(goal),
        text: (goal) => getGoalFaq(goal),
    },
    {
        title: () => "How and when should I take my Gainful products?",
        text: () => 'Great question! Checkout your <a style="text-decoration: underline;" href="/app/howtolp/">Product Use Guide</a>, personalized for you, that can be found in the RD Hub above. This guide should help answer questions around when to take your products,  how often to take them, and explain how they fit into your daily routine. Following these tips will help you get most of your Gainful subscription. Need more help?  I am always available to answer additional questions you may have about your Gainful products. ',
    },
    {
        title: () => "What is the right macronutrient breakdown for me?",
        text: () => 'Macronutrient distributions for each person can be different, and depend on a variety of factors such as your body composition and your goals. You can calculate your specific macros breakdown in our <a style="text-decoration: underline;" href="/app/rd-tool/">Macro tool here</a> (also can be found above in the RD Hub). Feel free to reach out if you have any questions regarding your macros and our team of RDs will be happy to help. ',
    },
    {
        title: () => "Should I consume my protein powder on days I don't workout?",
        text: () => "Protein needs are increased on days that you are working, however, protein itself is still an important nutrient to consume enough on other days as well. If you are already consuming enough protein through food on rest days, then you can decide to only use your protein powder on days you workout. Otherwise, feel free to include it in your everyday diet as a tasty, healthy and high protein option.",
    },
    {
        title: () => "I’m struggling to hit my goals. What am I doing wrong?",
        text: (goal) => `${goal} does not happen overnight. It can be challenging to stay consistent in your routines. To better understand the challenges you are facing, take this short <a style="text-decoration: underline;"  href="/quiz-new/quiz_rd>RD Check In Survey</a> and your RD will reach out with specific guidance on how to help you progress forward in hitting your goals.`,
    },
];
export const allRdsData = [
    {
        name: "Mary",
        img: mary,
        credentials: ["Registered Dietitian (RD)", "Certified Dietitian Nutritionist in NY (CDN)"],
        bio: "Mary is a Registered Dietitian who enjoys providing personalized, 1:1 nutrition and wellness guidance to help people confidently reach their unique health goals.",
        expertise: ["Body recomposition", "Sustaining dieting practices", "Healthy weight gain"],
        long_bio: "Mary is a certified Registered Dietitian (RD) and Certified Dietitian Nutritionist in NY (CDN). She has been working as an RD for the past 4 years, based in New York City. Prior to joining Gainful in 2020, Mary worked in a variety of spaces supporting nutrition, both clinical and in the community. Mary enjoys helping people realize that nutrition doesn’t need to be complicated but it can be a powerful tool for reaching your goals. She loves the freedom to be innovative and create personalized solutions for each customer to feel their best.",
        video: "https://vimeo.com/759527959",
        fun_facts: [
            {
                icon: "🎭",
                text: "Minored in theatre at Penn State",
            },
            {
                icon: "🍕🍕",
                text: "Averages 2 slices of pizza per week",
            },
        ],
    },
    {
        name: "",
        img: "",
        credentials: [""],
        bio: "",
        expertise: [""],
        video: "",
        long_bio: "",
        fun_facts: []
    },
    {
        name: "Matt",
        img: matt,
        credentials: ["Registered Dietitian (RD)", "Licensed Dietitian in OH (LD)"],
        bio: "Matt is a Registered Dietitian who has worked in a variety of different settings as an RD, and loves to pair his passion for fitness with nutrition. ",
        expertise: ["Muscle Gain", "Calories and Macronutrients", "Fat Loss"],
        long_bio: "Matt is a Registered Dietitian (RD) and Licensed Dietitian in OH (LD) based in Cincinnati, Ohio. He has been working as an RD for the past 5 years with Gainful. He has prior experience in nutrition support, acute care and rehabilitation hospitals, as well as general outpatient care. He previously competed in bodybuilding and powerlifting competitions, which is originally what led him to become a dietitian. Matt loves getting to help people with their health and fitness goals every single day through a combination of food, supplements, exercise, and lifestyle factors. He finds it rewarding to work with a variety of people who have different goals but the same mission to improve themselves in some way.",
        video: "https://vimeo.com/759527986",
        fun_facts: [
            {
                icon: "🌨",
                text: "Loves the cold weather",
            },
            {
                icon: "🍦",
                text: "Ice cream is his weakness",
            },
        ],
    },
    {
        name: "Ed",
        img: edwin,
        credentials: ["Registered Dietitian (RD)", "Certified Dietitian Nutritionist in NY (CDN)"],
        bio: "Ed is a Registered Dietitian who also works as a clinical nutrition manager, and is a personal trainer, too.",
        expertise: ["Sports nutrition", "Healthy weight gain/loss", "Cultural food diversity"],
        long_bio: "Edwin is a Registered Dietitian (RD) and Certified Dietitian Nutritionist in NY (CDN) based in Queens, New York. He has been working as an RD for the past 5 years, joining Gainful in early 2022. Outside of Gainful, Edwin works as a Clinical Nutrition Manager in an NYC Hospital. Prior to becoming an RD, Edwin spent years as a personal trainer and still conducts free exercise classes for the community members of the town he is based, which they love! Edwin enjoys combining his love for nutrition and fitness together to educate those who want to learn more directly.",
        video: "https://vimeo.com/759527915",
        fun_facts: [
            {
                icon: "🎸",
                text: "Enjoys playing the guitar",
            },
            {
                icon: "💭",
                text: "His dream career was to be a ninja turtle when he was a child",
            },
        ],
    },
    {
        name: "Tiff",
        img: tiffany,
        credentials: ["Registered Dietitian Nutritionist (RDN)"],
        bio: "Tiff is a Registered Dietitian who also works at Exos, and takes pride in being a reliable source of credible information for her clients.",
        expertise: ["Sports nutrition", "Intuitive eating", "Calories & Macronutrientsy"],
        long_bio: "Tiff is a Registered Dietitian Nutritionist (RDN) based in New York City. She has been working as an RD for the past 5 years and joined Gainful in 2020. Tiff also works at Exos Corporate Wellness and has her own private practice for nutrition consulting. She has experience in a variety of spaces; from working in public health to working 1:1 with Collegiate athletes preparing for their competitive seasons. Tiff also competed in powerlifting for 6 years, on the local and national levels. Tiff loves to be a reliable, credible source to individuals navigating the fitness and nutrition space with the goal of positively impacting people's lives.",
        video: "https://vimeo.com/759528048",
        fun_facts: [
            {
                icon: "🎧",
                text: "Loves a good crime podcast",
            },
            {
                icon: "☕",
                text: "Is a coffee junkie",
            },
        ],
    },
    {
        name: "Laine",
        img: laine,
        credentials: ["Registered Dietitian (RD)", "Certified Dietitian Nutritionist in NY (CDN)"],
        bio: "Laine is a Registered Dietitian who also works in long term care. She enjoys being able help people with their nutrition and work with other RDs at Gainful",
        expertise: ["Performance nutrition", "Lifestyle modification", "Recipes"],
        long_bio: "Laine is a Registered Dietitian (RD) and Certified Dietitian Nutritionist in NY (CDN) based in New York City. She has been practicing for nearly 3 years and joined Gainful in April 2021. Laine also works at a long-term care/sub-acute rehabilitation facility and for a private practice doing nutrition counseling and nutritional media writing. Laine double majored in dance and nutrition in college and enjoys working with performers and actors. She currently works with Broadway and Hollywood actors to prepare them for the physical demands of 8-show weeks or changing body composition based on a particular role someone is playing in a movie!",
        video: "https://vimeo.com/759530552",
        fun_facts: [
            {
                icon: "🩰",
                text: "Majored in Dance at the University of Alabama",
            },
            {
                icon: "🪄",
                text: "Claims to be the world’s greatest Harry Potter fan",
            },
        ],
    },
    {
        name: "Monica",
        img: monica,
        credentials: ["Masters of Science (MS)", "Registered Dietitian (RD)", "Certified Personal Trainer (CPT)"],
        bio: "Monica is a Registered Dietitian who also owns her own practice, and with Gainful, enjoys bringing individualized nutrition to every body.",
        expertise: [
            "Sports nutrition/Pro Sports (Basketball/NFL Combine)",
            "Healthy Mindset/ Relationship with Food",
            "Food & Mental Health ",
        ],
        video: "https://vimeo.com/759528004",
        long_bio: "Monica is a Registered Dietitian (RD) and Certified Personal Trainer (CPT) based in Denver, CO. She has been working as an RD for over 6 years in a variety of spaces. Prior to Gainful, Monica was the Denver Nuggets Team Nutritionist in addition to seeing clients through her private practice for nutrition and fitness coaching. Monica also has a strong role in the media, where she speaks on TV segments across the country about healthy recipes and nutrition tips. For fun, Monica teaches group fitness classes at a women-owned fitness studio in Denver. She loves the ability to combine fitness and nutrition to help people reach their goals, which is what brought her to Gainful.",
        fun_facts: [
            {
                icon: "🎭",
                text: "Childhood dream was to be an actress",
            },
            {
                icon: "🎸",
                text: "Goose is her favorite band",
            },
        ],
    },
    {
        name: "Shana",
        img: shana,
        credentials: ["Masters in Public Health Nutrition (MPH)", "Registered Dietitian (RD)"],
        bio: "Shana is a Registered Dietitian who also works in the inpatient setting, and values providing evidence based nutrition.",
        expertise: ["Sports Nutrition", "Pediatrics", "Health Education and Research", "Mental Health"],
        video: "https://vimeo.com/759528035",
        long_bio: "Shana is a Registered Dietitian (RD), with a Master’s in Public Health Nutrition (MPH). She is based in San Francisco, CA, and joined Gainful in August of 2022. Outside of Gainful, Shana works as an inpatient clinical dietitian and has prior experience with public health and nutrition research. Shana is a former D1 collegiate gymnast and now enjoys Bikram yoga and boxing. ",
        fun_facts: [
            {
                icon: "✈️",
                text: "Enjoys traveling, tries to travel to one new country a year",
            },
            {
                icon: "🥭",
                text: "Favorite dessert is mango sorbet",
            },
        ],
    },
];
